import Vue from 'vue'
// Lib imports
import axios from 'axios'
import globals from '../globals'

const base = axios.create({
  baseURL: globals.get('apiSvrUrl')
})

// Add a request interceptor
base.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers['Authorization'] = "DO_NOT_NEED"
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});


Vue.prototype.$http = base 


